import { autoMount } from '../../../utils/autoMount';
import { PickupBrands } from '../../../components/organisms/pickupBrands';

autoMount({ PickupBrands });
